import React from 'react';

import { LargePlus, PriceTag } from 'src/app/components/icons';

import {
  Card,
  CardTitle,
  Container,
  Description,
  DescriptionText,
  DescriptionTitle,
  DescriptionWithIcon,
  HelperText,
  IconContainerInner,
  IconContainerOuter,
  ProductSlot,
  ProductSlots,
  SectionTitle,
} from './styled';
import { useGamificationCardConfiguration } from './use-gamification-card-configuration';

export function GamificationCard() {
  const gamificationCardConfiguration = useGamificationCardConfiguration();
  const { type } = gamificationCardConfiguration;

  if (type === 'hidden') {
    return null;
  }

  const showProductSlots = type === 'numberOfItems' && gamificationCardConfiguration.numberOfProductSlots > 0;

  const { descriptionText, title } = gamificationCardConfiguration;

  return (
    <Container>
      <SectionTitle>Special Offer Gamification</SectionTitle>
      <Card>
        <CardTitle>{title}</CardTitle>
        {showProductSlots && (
          <ProductSlots $numberOfColumns={getNumberOfColumns(gamificationCardConfiguration.numberOfProductSlots)}>
            {Array.from({ length: gamificationCardConfiguration.numberOfProductSlots }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <ProductSlot key={`product-slot-${index}`}>
                <LargePlus />
              </ProductSlot>
            ))}
          </ProductSlots>
        )}
        <DescriptionWithIcon>
          <IconContainerOuter>
            <IconContainerInner>
              <PriceTag />
            </IconContainerInner>
          </IconContainerOuter>
          <Description>
            <DescriptionTitle>Get the offer!</DescriptionTitle>
            <DescriptionText>{descriptionText}</DescriptionText>
          </Description>
        </DescriptionWithIcon>
      </Card>
      <HelperText>
        Special offer gamification displays in a variety of locations to help improve shoppers' awareness of special
        offers and steps required to complete the offer.
      </HelperText>
    </Container>
  );
}

// https://github.com/GetDutchie/Dutchie/blob/develop/marketplace/src/components/special-card/offer.tsx#L50
// we want our preview to look like the marketplace card, so we need to use the same logic
const getNumberOfColumns = (numberOfItems: number): number => {
  if (numberOfItems <= 4) {
    return numberOfItems;
  }
  if (numberOfItems <= 6) {
    return 3;
  }
  if (numberOfItems <= 8) {
    return 4;
  }
  return 5;
};
